// components/CustomLink.js
"use client";
import React from "react";
import Link from "next/link";
import PropTypes from "prop-types";

const CustomLink = ({
  href, // The target link
  label, // Text to be displayed on the link
  className = "", // Custom Tailwind classes for styling
  size = "medium", // Size of the text (small, medium, large)
  variant = "primary", // Style variant (primary, secondary, etc.)
  isDisabled = false, // Disable link if true
  target = "_self", // Define the target attribute (default: _self)
  ...props // Other props (e.g., onClick)
}) => {
  // Dynamic link styles based on size and variant
  const baseStyles = "transition-all duration-200";
  const sizeStyles = {
    small: "text-sm",
    medium: "text-base",
    large: "text-lg",
  };
  const variantStyles = {
    primary: "text-blue-500 hover:text-blue-600",
    secondary: "text-gray-500 hover:text-gray-600",
    danger: "text-red-500 hover:text-red-600",
    success: "text-green-500 hover:text-green-600",
  };

  // Combine styles dynamically
  const linkStyles = `${baseStyles} ${sizeStyles[size]} ${
    variantStyles[variant]
  } ${isDisabled ? "cursor-not-allowed opacity-50" : ""} ${className}`;

  return (
    <Link
      href={!isDisabled ? href : "#"}
      target={target}
      className={linkStyles}
      {...props}
      aria-disabled={isDisabled ? "true" : undefined} // For accessibility
    >
      {label}
    </Link>
  );
};

CustomLink.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  variant: PropTypes.oneOf(['primary', 'secondary', 'danger', 'success']),
  isDisabled: PropTypes.bool,
  target: PropTypes.string,
};

export default CustomLink;
